import React from "react";

var SpsCardHeader = function SpsCardHeader(props) {
    var title = props.title,
        content = props.content,
        icon = props.icon;

    return React.createElement(
        "div",
        { className: "sps-card__header", title: title },
        React.createElement(
            "h4",
            { className: "sps-card__title" },
            " ",
            icon && React.createElement("i", { "aria-hidden": "true", className: "sps-icon sps-icon-" + icon }),
            " ",
            title
        ),
        React.createElement(
            "div",
            { className: "sps-card__header-content" },
            content
        )
    );
};

export default SpsCardHeader;